var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("catalogService", [
    "$http",
    "$httpParamSerializer",
    function ($http, $httpParamSerializer) {
        return {
            //Converts stock_design => Stock Design
            capitalizeFirstLetter: function (str) {
                return str
                    .split("_")
                    .map(function (word) {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    })
                    .join(" ");
            },
            productDefinition: {
                clubMembership: "ClubMembership",
                customDigitizing: "CustomDigitizing",
                merchandise: "Merchandise",
                designPack: "DesignPack",
                font: "Font",
                fontPack: "FontPack",
                giftCertificate: "GiftCertificate",
                instantLettering: "InstantLettering",
                software: "Software",
                stockDesign: "StockDesign",
                subscription: "Subscription",
                thread: "Thread",
                svg: "SVG",
                printart: "PrintArt",
                supplies: "Supplies",
                projectPack: "ProjectPack",
                quilting: "Quilting",
                equipment: "Equipment",
                embroiderable: "Embroiderable",
                education: "Education",
                handembroidery: "Hand Embroidery",
                video: "Video",
                collection: "Collection",
                sewingpdfpatterns: "Sewing PDF Patterns",
                knittingpdfpatterns: "Knitting PDF Patterns",
                crochetpdfpatterns: "Crochet PDF Patterns",
                clothingpdfpatterns: "Clothing PDF Patterns",
                crossstitchpdfpatterns: "Cross Stitch PDF Patterns",
                fabric: "Fabric",
                machine: "Machine",
                foundationpaperpiecingpdfpatterns:
                    "Foundation Paper Piecing PDF Patterns",
                quiltingpdfpatterns: "Quilting PDF Patterns",
                embroiderypatch: "EmbroideryPatch",
            },
            productType: {
                digital: "Digital",
                physical: "Physical",
            },
            fontTypes: {
                homeformatfonts: "Home Format Fonts",
                embrilliancefonts: "Embrilliance Fonts",
                appliquefonts: "Applique Fonts",
                pulsefonts: "Pulse Fonts",
                efpfonts: "EFP Fonts",
                monograms: "Monograms",
                wilcomfonts: "Wilcom Fonts",
            },
            getProductsByIds: function (productIds, respGroup) {
                return $http.get(
                    "storefrontapi/products?" +
                        $httpParamSerializer({ productIds: productIds }) +
                        "&respGroup=" +
                        respGroup +
                        "&t=" +
                        new Date().getTime()
                );
            },
            isCustomDigitizing: function (productDefinition) {
                return (
                    (productDefinition && productDefinition.toLowerCase()) ==
                    this.productDefinition.customDigitizing.toLowerCase()
                );
            },
            isInstantLettering: function (productDefinition) {
                return (
                    (productDefinition && productDefinition.toLowerCase()) ==
                    this.productDefinition.instantLettering.toLowerCase()
                );
            },
            isClubMembership: function (productDefinition) {
                return (
                    (productDefinition && productDefinition.toLowerCase()) ==
                    this.productDefinition.clubMembership.toLowerCase()
                );
            },
            isDigitalProduct: function (productType) {
                return (
                    (productType && productType.toLowerCase()) ==
                    this.productType.digital.toLowerCase()
                );
            },
            isGiftCard: function (productDefinition) {
                return (
                    (productDefinition && productDefinition.toLowerCase()) ==
                    this.productDefinition.giftCertificate.toLowerCase()
                );
            },
            isInstantLettering: function (productDefinition) {
                return (
                    (productDefinition && productDefinition.toLowerCase()) ==
                    this.productDefinition.instantLettering.toLowerCase()
                );
            },
            isStockDesign: function (productDefinition) {
                return (
                    (productDefinition && productDefinition.toLowerCase()) ==
                    this.productDefinition.stockDesign.toLowerCase()
                );
            },
            isSubscription: function (productDefinition) {
                return (
                    (productDefinition && productDefinition.toLowerCase()) ==
                    this.productDefinition.subscription.toLowerCase()
                );
            },
            isThread: function (productDefinition) {
                return (
                    productDefinition &&
                    productDefinition.toLowerCase() ==
                        this.productDefinition.thread.toLowerCase()
                );
            },
            isVideo: function (productDefinition) {
                return (
                    productDefinition &&
                    productDefinition.toLowerCase() ==
                        this.productDefinition.video.toLowerCase()
                );
            },
            getFrequentlyBoughtProducts: function (itemId) {
                return $http.get(
                    "storefrontapi/getboughttogetheritems?itemId=" + itemId
                );
            },
        };
    },
]);
